import * as React from 'react';
import {
    List,
    Datagrid,
    BooleanInput,
    BooleanField,
    DateField,
    TextField,
    SearchInput,
    TextInput,
} from 'react-admin';
import { useMediaQuery, Theme } from '@mui/material';

import MobileGrid from './MobileGrid';

const entityFilters = [
    <SearchInput source="q" alwaysOn />,
    <TextInput source="id" />,
    <TextInput source="title" />,
    <BooleanInput source="active" />,
];

const EntityList = () => {
    const isXsmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );
    // const isSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('md'));
    return (
        // @ts-ignore
        <List
            filters={entityFilters}
            sort={{ field: 'id', order: 'DESC' }}
            perPage={25}
        >
            {isXsmall ? (
                <MobileGrid />
            ) : (
                <Datagrid
                    optimized
                    rowClick="edit"
                    sx={{
                        '& .column-groups': {
                            md: { display: 'none' },
                            lg: { display: 'table-cell' },
                        },
                    }}
                >
                    <TextField source="id" />
                    <TextField source="title" />
                    <TextField source="domain" />
                    <BooleanField source="active" />
                    <TextField source="email" />
                    <TextField source="cities_item.title_selector" />
                    <DateField source="created" showTime={true} />
                    <DateField source="modified" showTime={true} />
                </Datagrid>
            )}
        </List>
    );
};

export default EntityList;
